export const LIVE_CHAT_COUNTRY_WHITELIST = [
  'AR',
  'AU',
  'BR',
  'CL',
  'CO',
  'CR',
  'ID',
  'JP',
  'KR',
  'MX',
  'MY',
  'PE',
  'PH',
  'SG',
  'TH',
  'US',
  'VN'
];

// List of drift supported langauges https://help.drift.com/article/custom-language/
// Passing an unsupported language will break drift.
export const DRIFT_LANGUAGES = [
  'en',
  'es',
  'de',
  'de-DE',
  'de-DE-formal',
  'hi',
  'hu',
  'et',
  'is',
  'nl',
  'pt',
  'pt-PT',
  'pt-BR',
  'sv',
  'zh',
  'fr',
  'it',
  'ru',
  'pl',
  'sl',
  'da',
  'fi',
  'hr',
  'ko',
  'nb',
  'ro',
  'sr',
  'th',
  'vi'
];

export const DRIFT_DETAILS = {
  Product_Interests: 'Workspace',
  Lead_Source: 'WeWork.com',
  Lead_Source_Subtype_: 'Chat',
  Lead_Source_Detail_: '',
  Create_Source: 'WeWork.com'
};
